import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";

const istStartOfToday = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

const istEndOfToday = () => {
  const d = new Date();
  d.setHours(23, 59, 59, 999);
  return d;
};

export default function DistributorPendingDashboard() {
  const [pendingParties, setPendingParties] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);

    // 1️⃣ Hawker parties
    const hawkerSnap = await getDocs(
      query(
        collection(db, "partyMaster"),
        where("partytype", "==", "hawker")
      )
    );

    const hawkerPartyIds = hawkerSnap.docs.map(
      d => d.data().partyId
    );

    // 2️⃣ Pending orders today
    const pendingSnap = await getDocs(
      query(
        collection(db, "orders"),
        where("status", "==", "PENDING"),
        where("createdAt", ">=", istStartOfToday()),
        where("createdAt", "<=", istEndOfToday())
      )
    );

    const pendingPartySet = new Set(
      pendingSnap.docs.map(d => d.data().partyId)
    );

    // 3️⃣ Compute not placed
    const notPlaced = hawkerPartyIds.filter(
      pid => !pendingPartySet.has(pid)
    );

    setPendingParties(notPlaced);
    setLoading(false);
  };

  return (
    <Layout>
      <div className="layout-content">
        {/* HEADER */}
        <div style={{ marginBottom: 40, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
            <div>
                <div style={{ fontSize: 12, fontWeight: 700, color: "var(--primary)", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>Operations Control</div>
                <h1 style={{ margin: 0, fontSize: 32 }}>Order Compliance</h1>
                <p style={{ marginTop: 4, color: "var(--text-muted)" }}>Real-time status of distributor commitments</p>
            </div>
            <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: 24, fontWeight: 800 }}>{new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short" })}</div>
                <div style={{ fontSize: 12, color: "var(--text-muted)", textTransform: "uppercase" }}>Audit Cycle: Daily</div>
            </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 32 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
                {/* SUMMARY CARD */}
                <div className="premium-card" style={{ padding: 32, borderLeft: `4px solid ${pendingParties.length > 0 ? "var(--error)" : "var(--success)"}` }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", marginBottom: 12 }}>Unresponsive Parties</div>
                  <div style={{ display: "flex", alignItems: "baseline", gap: 12 }}>
                      <div style={{ fontSize: 56, fontWeight: 800, color: pendingParties.length > 0 ? "var(--error)" : "var(--success)" }}>
                        {pendingParties.length}
                      </div>
                      <div style={{ fontSize: 14, color: "var(--text-muted)" }}>Required immediate action</div>
                  </div>
                  <div style={{ marginTop: 20, height: 6, background: "var(--surface-hover)", borderRadius: 3, overflow: "hidden" }}>
                      <div style={{ width: `${Math.min(100, (pendingParties.length / 50) * 100)}%`, height: "100%", background: "var(--error)" }}></div>
                  </div>
                </div>

                <div className="premium-card" style={{ padding: 24, background: "var(--surface-hover)", border: "1px dashed var(--border)" }}>
                  <h4 style={{ marginBottom: 12 }}>System Intelligence</h4>
                  <p style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.6 }}>
                    Parties listed here have zero activity in the current session. Automated reminders will be dispatched at 14:00 IST if status remains PENDING.
                  </p>
                </div>
            </div>

            {/* TABLE CARD */}
            <div className="premium-card" style={{ padding: 0, overflow: "hidden" }}>
              <div style={{ padding: "20px 24px", borderBottom: "1px solid var(--border)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h3 style={{ margin: 0 }}>Parties Awaiting Submission</h3>
                <span className="tb-status-pill status-offline" style={{ fontSize: 11 }}>Action Required</span>
              </div>

              <div style={{ maxHeight: 500, overflowY: "auto" }}>
                  {loading ? (
                    <div style={{ padding: 40, textAlign: "center", color: "var(--text-muted)" }}>Scanning database...</div>
                  ) : pendingParties.length === 0 ? (
                    <div style={{ padding: 60, textAlign: "center" }}>
                        <div style={{ fontSize: 40, marginBottom: 16 }}>🏆</div>
                        <div style={{ fontWeight: 700, fontSize: 18 }}>Fully Compliant</div>
                        <p style={{ color: "var(--text-muted)", fontSize: 14 }}>All distributor parties have submitted orders for today.</p>
                    </div>
                  ) : (
                    <table className="enterprise-table">
                      <thead>
                        <tr>
                          <th>Distributor Identity</th>
                          <th style={{ textAlign: "right" }}>System Access</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendingParties.map((pid) => (
                          <tr key={pid}>
                            <td style={{ fontWeight: 700, color: "var(--text-main)" }}>
                              {pid}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <button
                                onClick={() =>
                                  navigate(
                                    `/distributor-order?partyId=${encodeURIComponent(pid)}`
                                  )
                                }
                                className="btn-primary"
                                style={{ padding: "8px 16px", fontSize: 13 }}
                              >
                                Forced Entry
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
              </div>
            </div>
        </div>
      </div>
    </Layout>
  );

}
